var map = {
  "./km.json": [
    "713030",
    "125373"
  ],
  "./ru.json": [
    "850154",
    "431166"
  ],
  "./bg.json": [
    "775240",
    "94966"
  ],
  "./el.json": [
    "293091",
    "574115"
  ],
  "./en-pt.json": [
    "939457",
    "699864"
  ],
  "./ja.json": [
    "565369",
    "999983"
  ],
  "./ar.json": [
    "569970",
    "336137"
  ],
  "./rw.json": [
    "333311",
    "742346"
  ],
  "./sr.json": [
    "978216",
    "268680"
  ],
  "./lol.json": [
    "537755",
    "344452"
  ],
  "./fr.json": [
    "189085",
    "221986"
  ],
  "./sv.json": [
    "747574",
    "276350"
  ],
  "./as.json": [
    "585920",
    "994333"
  ],
  "./gu.json": [
    "333147",
    "557814"
  ],
  "./kk.json": [
    "361072",
    "673378"
  ],
  "./nb.json": [
    "341355",
    "808353"
  ],
  "./ta.json": [
    "16225",
    "214721"
  ],
  "./ky.json": [
    "924774",
    "231627"
  ],
  "./pl.json": [
    "29123",
    "423974"
  ],
  "./ro.json": [
    "896001",
    "478603"
  ],
  "./ka.json": [
    "401607",
    "192678"
  ],
  "./hu.json": [
    "228402",
    "960476"
  ],
  "./uk.json": [
    "641339",
    "734169"
  ],
  "./or.json": [
    "521915",
    "340404"
  ],
  "./uz.json": [
    "69557",
    "686257"
  ],
  "./hy.json": [
    "476",
    "601351"
  ],
  "./de.json": [
    "515813",
    "353649"
  ],
  "./pt-pt.json": [
    "333438",
    "881017"
  ],
  "./vi.json": [
    "395952",
    "149439"
  ],
  "./tr.json": [
    "889624",
    "207994"
  ],
  "./da.json": [
    "268617",
    "403937"
  ],
  "./kn.json": [
    "489561",
    "358498"
  ],
  "./mr.json": [
    "445427",
    "292680"
  ],
  "./id.json": [
    "331425",
    "983976"
  ],
  "./lt.json": [
    "269508",
    "691183"
  ],
  "./lv.json": [
    "443858",
    "170500"
  ],
  "./zh-hans.json": [
    "70920",
    "227144"
  ],
  "./es.json": [
    "995567",
    "574413"
  ],
  "./ko.json": [
    "400328",
    "695683"
  ],
  "./te.json": [
    "844223",
    "126613"
  ],
  "./bn.json": [
    "420691",
    "764981"
  ],
  "./cs.json": [
    "867595",
    "720442"
  ],
  "./boxes.json": [
    "981805",
    "771742"
  ],
  "./my.json": [
    "400576",
    "579967"
  ],
  "./mn.json": [
    "113133",
    "346705"
  ],
  "./nl.json": [
    "611074",
    "508890"
  ],
  "./az.json": [
    "976631",
    "345596"
  ],
  "./accents.json": [
    "909692",
    "384702"
  ],
  "./pa.json": [
    "952433",
    "339390"
  ],
  "./pt.json": [
    "379137",
    "227518"
  ],
  "./extra.json": [
    "716800",
    "224209"
  ],
  "./it.json": [
    "145633",
    "949437"
  ],
  "./hi.json": [
    "805415",
    "304461"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 243151;
module.exports = webpackAsyncContext;
